import { render, staticRenderFns } from "./TaskFocusDetails.vue?vue&type=template&id=a842efb6&scoped=true&"
import script from "./TaskFocusDetails.vue?vue&type=script&lang=js&"
export * from "./TaskFocusDetails.vue?vue&type=script&lang=js&"
import style0 from "./TaskFocusDetails.vue?vue&type=style&index=0&id=a842efb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a842efb6",
  null
  
)

export default component.exports